<template>
  <FrontPageTmpl @openFreeTrial="openFreeTrial" ref="tmpl">
    <div class="about-box">
      <div class="about-banner"></div>
      <div class="about-content">
        <section>
          <strong> 亿景智联</strong>
          （<a href="https://www.changjing.com.cn" target="_blank"
            >www.changjing.com.cn</a
          >）是由人工智能领军企业前百度的智能城市业务负责人创建，作为人工智能场景开发与运营商，致力于打造基于“场景”挖掘与运营的人工智能技术赋能与创新平台，通过场景挖掘、技术赋能、模式创新，全面降低人工智能创新门槛，加速人工智能创新裂变。
        </section>
        <section>
          依托自有技术及强大的生态合作伙伴，亿景智联的产品与方案覆盖了城市、园区、社区、产业等各个层面，构建城市大数据洞察平台、产业园区赋能平台、智慧生活赋能平台、产业生态赋能平台，为城市、产业园区、传统产业企业提供全方位的AI赋能解决方案。地图无忧，是亿景智联旗下一款强大的SaaS化时空大数据平台产品，已经服务于众多行业和企业。
        </section>
        <section>
          公司总部坐落于北京市海淀区，核心团队由在地理信息、云计算、大数据、人工智能等领域具有十余年工作经验的博士、硕士和资深专家组成，具备丰富的商业企业、政府智慧化项目研发实力和实施经验。公司产品自上线以来，已为全国近千家企业提供了专业的产品、咨询服务和解决方案，为客户节省了大量成本，并极大的提升了运营效率。为了更近更快的响应客户需求，完善本地服务能力，公司陆续在上海、广州设立区域分支机构，让地理信息价值和位置智能在全球每个角落都能被快速挖掘和激活。
        </section>
        <section>
          专业资质认证
          <div class="img-content">
            <img
              v-for="(img, index) in imgList"
              :key="`img_${index}`"
              :src="img"
              :class="index !== 0 ? 'dt-mar10l' : ''"
            />
          </div>
        </section>
        <section>
          强大的战略投资方
          <div class="logo-content">
            <img
              v-for="(logo, index) in logoList"
              :key="`logo_${index}`"
              :src="logo"
              :width="index !== 2 ? 220 : 140"
              :class="index !== 0 ? 'dt-mar10l' : ''"
            />
          </div>
        </section>
        <section>
          <p class="weight">联系方式</p>
          <p>商务合作：400-888-9725 按 1 键</p>
          <p>技术支持：400-888-9725 按 2 键</p>
          <p>微信公众号：dituwuyou</p>
          <p>地址：北京市海淀区自主创新大厦3015</p>
        </section>
      </div>
    </div>
    <MyModal v-if="freeTrialShow" @closeMyModal="closeFreeTrial">
      <FreeTrial @success="applyTrialSuccess"></FreeTrial>
    </MyModal>
    <MyModal
      v-if="applyTrialSuccessModalShow"
      @closeMyModal="closeFreeTrialSuccessModal"
    >
      <ApplyTrialSuccess></ApplyTrialSuccess>
    </MyModal>
  </FrontPageTmpl>
</template>
<script>
import FrontPageTmpl from "./FrontPageTmpl.vue";
import MyModal from "./MyModal.vue";
import FreeTrial from "./FreeTrial.vue";
import ApplyTrialSuccess from "../components/ApplyTrialSuccess.vue";
export default {
  data() {
    return {
      freeTrialShow: false,
      applyTrialSuccessModalShow: false
    };
  },
  methods: {
    openFreeTrial() {
      this.freeTrialShow = true;
    },
    closeFreeTrial() {
      this.freeTrialShow = false;
    },
    closeFreeTrialSuccessModal() {
      this.applyTrialSuccessModalShow = false;
    },
    // 申请试用成功
    applyTrialSuccess() {
      this.closeFreeTrial();
      this.applyTrialSuccessModalShow = true;
      setTimeout(() => {
        this.closeFreeTrialSuccessModal();
      }, 5000);
    }
  },
  components: {
    FrontPageTmpl,
    MyModal,
    FreeTrial,
    ApplyTrialSuccess
  }
};
</script>

<style lang="scss">
@import "../assets/stylesheets/about";
</style>



// WEBPACK FOOTER //
// src/components/About.vue